export const tableDictionary = {
  labelText: 'Sahifadagi qatorlar:',
  emptyData: "Ma'lumot topilmadi",
}
